export const locales = {
    id: {
        app_name: process.env.MIX_APP_NAME,
        app_description: process.env.MIX_APP_DESCRIPTION,
        id_lang: 'Bahasa Indonesia',
        en_lang: 'Bahasa Inggris',
        change_language: 'Ubah bahasa',
        login: 'Masuk',
        logout: 'Keluar',
        login_with_google: 'Masuk dengan google',
        login_success: 'Berhasil login!',
        welcome_to: 'Selamat datang di',
        uii: 'Universitas Islam Indonesia',
        faculty: process.env.MIX_FACULTY_NAME,
        required_field: 'Bidang ini tidak boleh kosong!',
        user: 'Pengguna',
        search: 'Cari',
        full_name: 'Nama lengkap',
        role: 'Otoritas',
        student_number: 'Nomor Induk Mahasiswa',
        employee_number: 'Nomor Induk Pegawai',
        phone_number: 'No HP',
        max_100: 'Nilai maksimal adalah 100',
        max_ipk: 'IPK maksimal adalah 4',
        format_no_hp: 'No. Hp harus angka',
        format_nilai_tidak_sesuai: 'Nilai tidak sesuai',
        page_not_found: 'Halaman tidak ditemukan :(',
        // Menu
        student_menu: 'Menu mahasiswa',
        internship: 'Kerja praktik',
        help_and_information: 'Bantuan & Informasi',
        officer_menu: 'Menu petugas',
        registration_verification: 'Verifikasi pendaftaran',
        letter_verification: 'Verifikasi surat balasan',
        recap_student: 'Rekapitulasi mahasiswa',
        manage_letter: 'Kelola surat',
        manage_rubric: 'Kelola rubrik',
        lecture_menu: 'Menu dosen',
        guidance_students: 'Mahasiswa bimbingan',
        admin_menu: 'Menu admin',
        manage_user: 'Kelola pengguna',
        edit:'Ubah',
        view: 'Lihat',
        unggah: 'Unggah dokumen',
        // Student Menu
        register: 'Daftar',
        info_not_register_yet: 'Kamu belum mendaftar kerja praktik, Silakan klik daftar untuk mendaftar KP',
        form_register_internship: 'Form pendaftaran KP',
        fill_in_the_form: 'Isian',
        // form student step 1
        registrations: 'Pendaftaran',
        tanggal_daftar_sistem: 'Tanggal daftar di sistem',
        tanggal_rencana_mulai_kp: 'Rencana mulai kp',
        tanggal_rencana_selesai_kp: 'Rencana selesai kp',
        kuliah_prasyarat: 'Kuliah prasyarat',
        perusahaan_tujuan: 'Nama perusahaan',
        alamat_perusahaan: 'Alamat perusahaan',
        kategori_perusahaan: 'Kategori perusahaan',
        bidang_topik: 'Topik perusahaan',

        D001: 'Kartu Hasil Studi Kumulatif',
        D002: 'Bukti pembayaran KP',
        D003: 'Proposal KP',
        // form student step 2
        submission_on_verification_officer: 'Pendaftaran KP sedang diverifikasi petugas.',
        waiting_for_verification: 'Menunggu verifikasi petugas',
        // tanggal_realisasi_mulai_kp: 'Realisasi mulai kp',
        // kode_jenis_surat: undefined,
        // dokumen: undefined,
        // // form student step 3
        // D004: undefined,
        // D005: undefined,
        // D006: undefined,
        // D008: undefined,
        // // form student step 4
        // berita_acara: undefined,
        // tanggal_realisasi_selesai_kp: undefined


    },
    en: {
        app_name: process.env.MIX_APP_NAME_EN,
        app_description: process.env.MIX_APP_DESCRIPTION_EN,
        id_lang: 'Indonesian',
        en_lang: 'English',
        change_language: 'Change language',
        login: 'Login',
        logout: 'Logout',
        login_with_google: 'Login with google',
        login_success: 'Login success!',
        welcome_to: 'Welcome to',
        uii: 'Islamic University of Indonesia',
        faculty: process.env.MIX_FACULTY_NAME_EN,
        required_field: 'This field is required!',
        user: 'User',
        full_name: 'Full name',
        role: 'Role',
        student_number: 'Student Number',
        employee_number: 'Employee Number',
        phone_number: 'No HP',
        max_100: 'Maximum value 100',
        max_ipk: 'Maximum IPK 4',
        format_no_hp: 'No. Hp must be number',
        format_nilai_tidak_sesuai: 'Please check your input',
        page_not_found: 'Page not found :(',
        // Menu
        student_menu: 'Student menu',
        internship: 'Internship',
        help_and_information: 'Help & Information',
        officer_menu: 'Officer menu',
        registration_verification: 'Registration verification',
        letter_verification: 'Letter verification',
        recap_student: 'Student recap',
        manage_letter: 'Manage letter',
        manage_rubric: 'Manage rubric',
        lecture_menu: 'Lecture menu',
        guidance_students: 'Guidance students',
        admin_menu: 'Admin menu',
        manage_user: 'Manage user',
        edit:'Edit',
        view: 'View',
        // Student Menu
        unggah: 'Upload document',
        register: 'Register',
        info_not_register_yet: 'You have not registered for Practical work/Internship, please click register.',
        form_register_internship: 'Internship registration form',
        fill_in_the_form: 'Fill',
        // form student step 1
        registrations: 'Registration',
        tanggal_daftar_sistem: 'Date of registration',
        tanggal_rencana_mulai_kp: 'Planned internship start date',
        tanggal_rencana_selesai_kp: 'planned internship finish date',
        kuliah_prasyarat: 'Prerequisite courses',
        perusahaan_tujuan: 'Company name',
        alamat_perusahaan: 'Company address',
        kategori_perusahaan: 'Company type',
        kategori_perusahaan: 'Company topics',
        D001: 'Cumulative Study Results Card',
        D002: 'Proof of payment',
        D003: 'Internship proposal',
        // form student step 2
        submission_on_verification_officer: 'Applications for practical work are being verified by officers',
        waiting_for_verification: 'Waiting for verification',













    }
};